export interface AuthUser {
  sub: string;
  preferred_username?: string;
  email?: string;
  name?: string;
  resource_access?: Record<string, { roles: string[] }>;
}

export enum AppAuthStatusEnum {
  LOADING = "LOADING",
  AUTHENTICATED = "AUTHENTICATED",
  UNAUTHENTICATED = "UNAUTHENTICATED",
}

export interface AppAuthState {
  user: AuthUser | null;
  status: AppAuthStatusEnum;
}

export enum AppAuthActionEnum {
  AUTH_SET_USER = "AUTH_SET_USER",
  AUTH_CLEAR = "AUTH_CLEAR",
}

const initialState: AppAuthState = { user: null, status: AppAuthStatusEnum.LOADING };

type Action =
  | { type: AppAuthActionEnum.AUTH_SET_USER; value: AuthUser }
  | { type: AppAuthActionEnum.AUTH_CLEAR };

const appAuthReducer = (state: AppAuthState = initialState, action: Action): AppAuthState => {
  switch (action.type) {
    case AppAuthActionEnum.AUTH_SET_USER:
      return { user: action.value, status: AppAuthStatusEnum.AUTHENTICATED };
    case AppAuthActionEnum.AUTH_CLEAR:
      return { user: null, status: AppAuthStatusEnum.UNAUTHENTICATED };
    default:
      return state;
  }
};

export default appAuthReducer;

export const authSetUserAction = (user: AuthUser) => ({
  type: AppAuthActionEnum.AUTH_SET_USER,
  value: user,
});

export const authClearAction = () => ({ type: AppAuthActionEnum.AUTH_CLEAR });
